import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import Swal from 'sweetalert2';
import CustomTable from '../../helpers/custom-table-client'
import { catchError } from '../../helpers/catch-error-client'
import { NavLink } from "react-router-dom";



const ActiveWorkOrders = () => {
  const navigate = useNavigate();
   const [searchText, setSearchText] = React.useState("");
      const [appliedSearch, setAppliedSearch] = React.useState("");
  var columns = React.useMemo(
    () => [
      {
        accessorFn: row => row.work_order_id + "_" + row.work_order_no + "_" + row.is_updated,
        id: "work_order_id",
        cell: ({ getValue }) => (
          <a className={(getValue().split("_"))[2] == 1 ? "fw-bold text-shadow text-danger" : ""}
            href={"/client/work-order/" + (getValue().split("_"))[0]}
          >{(getValue().split("_"))[1]}</a>
        ),
        header: () => "ID",
        size: 100,
      },
      {
        accessorKey: "wo_creation_date",
        header: "Date",
        footer: props => props.column.id,
        size: 120,
      },
      {
        accessorFn: row => row.patient_last_name + " " + row.patient_first_name ,
        id: "lastName",
        cell: info => info.getValue(),
        header: () => "Patient",
        footer: props => props.column.id
      },
      {
        accessorKey: "facility_name",
        header: "FACILITY",
        footer: props => props.column.id
      },
      {
        accessorKey: "wo_request_submitted_by",
        header: "Created By",
        footer: props => props.column.id
      },
      {
        accessorKey: "client_company_name",
        header: "Client",
        footer: props => props.column.id
      },
      {
        accessorFn: row => <>

       
          {row.authorization_status == 0 && row.status >= 0.5 &&
          <>
            <div className="fw-bold text-danger ">PATIENT AUTHORIZATION NEEDED</div>
          
</>
          }

{row.blank_authorization_datetime && !row.wo_patient_special_authorization_datetime &&
          <>
            <div className="fw-bold text-danger ">[ON HOLD] URGENT ACTION NEEDED</div>
           
</>
          }

          {row.status == 0.5 &&
            <>
              <div className="fw-bold text-dark">PENDING MEDRECAPS APPROVAL</div>

            </>
          }
          {row.status == 2 &&
            <>
             <div className="fw-bold text-danger  bg-warning">URGENT ACTION NEEDED</div>
              <div className="fw-bold text-dark">ClIENT/CASE MANAGER ACTION REQUIRED</div>

            </>
          }

         

        </>,
        id: "notes",
        cell: info => info.getValue(),
        header: () => "NOTES",
        footer: props => props.column.id,
        size: 320,
        enableColumnFilter: false,
        enableSorting: false,
      },
/*
      {
        accessorFn: row => <>
          <a onClick={() => replicateWorkOrder(row.work_order_id)} href="javascript:void(0)" className="btn btn-link p-0 me-2" >Replicate</a>
          <a onClick={() => copyWorkOrder(row.work_order_id)} href="javascript:void(0)" className="btn btn-link m-0 p-0 me-2">Copy</a>
        
        </>,
        id: "actions",
        cell: info => info.getValue(),
        header: () => "ACTIONS",
        footer: props => props.column.id,
        enableColumnFilter: false,
        enableSorting: false,
        size: 200,


      }
*/



    ],
    []
  )


  const [data, setData] = React.useState(null);

  const getActiveWorkOrders = async () => {

    await axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/client/get-active-work-orders", {
      withCredentials: true
    })
      .then(function (response) {

        if (response?.data?.status) {

          setData(response?.data?.work_orders);

        } else {

          Swal.fire({ icon: "error", title: "Active Work Order Failed to Load" });

        }

      })
      .catch(function (error) {

        catchError(error, navigate)

      });

  }

 

  const copyWorkOrder = async (work_order_id) => {

    await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/client/copy-work-order", {
      work_order_id: work_order_id
    }, {
      withCredentials: true
    })
      .then(function (response) {

        if (response?.data?.status) {

          getActiveWorkOrders();
          Swal.fire({ icon: "success", title: "Work order copied successfully. " });

        } else {

          Swal.fire({ icon: "error", title: "Unable to copy work order " });

        }

      })
      .catch(function (error) {

        catchError(error, navigate)

      });


  }

  const replicateWorkOrder = async (work_order_id) => {

    await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/client/replicate-work-order", {
      work_order_id: work_order_id
    }, {
      withCredentials: true
    })
      .then(function (response) {

        if (response?.data?.status) {

          getActiveWorkOrders();
          Swal.fire({ icon: "success", title: "Work order replicated successfully. " });


        } else {

          Swal.fire({ icon: "error", title: "Unable to replicate work order" });

        }

      })
      .catch(function (error) {

        catchError(error, navigate)

      });


  }


  const filteredData = React.useMemo(() => {
    if (!appliedSearch?.trim()) return data;
  
    const search = appliedSearch.toLowerCase().trim();
    const searchTokens = search.split(" ").filter(Boolean);
  
    return data.filter((row) => {
      const first = (row.patient_first_name || "").toLowerCase().trim();
      const last = (row.patient_last_name || "").toLowerCase().trim();
  
      const fullName = `${first} ${last}`.trim();
      const reverseName = `${last} ${first}`.trim();
  
      // ✅ flexible patient matching (handles "john doe", "doe john", "jo do", etc.)
      const patientMatch = searchTokens.every((t) =>
        first.includes(t) ||
        last.includes(t) ||
        fullName.includes(t) ||
        reverseName.includes(t)
      );
  
      const facility = (row.facility_name || "").toLowerCase();
      const client = (row.client_company_name || "").toLowerCase();
      const createdBy = (row.wo_request_submitted_by || "").toLowerCase();
      const workOrderNo = (row.work_order_no || "").toLowerCase();
      const workOrderId = String(row.work_order_id || "").toLowerCase();
  
      const generalMatch =
        facility.includes(search) ||
        client.includes(search) ||
        createdBy.includes(search) ||
        workOrderNo.includes(search) ||
        workOrderId.includes(search);
  
      return patientMatch || generalMatch;
    });
  }, [data, appliedSearch]);
  
  
    const handleSearch = () => setAppliedSearch(searchText);
  
    const handleReset = () => {
      setSearchText("");
      setAppliedSearch("");
    };
  
  
  

  useEffect(() => {

    getActiveWorkOrders();

  }, []);

  return (
    <>

      {data &&

        <>

<div className="row py-2 start-0 bg-light">

            <div className="col-md-12 col-sm-12 mx-auto text-center">
              <div className="container-fluid z-2  ">

                <span className="btn btn-success rounded-0 me-1">
                  <NavLink className="nav-link" smooth to="/client/work-orders-active">
                    ACTIVE
                  </NavLink>
                </span>
                <span className="btn btn-warning rounded-0  me-1 ">
                  <NavLink className="nav-link" smooth to="/client/work-orders-records-obtained">
                    RECORDS OBTAINED
                  </NavLink>
                </span>

                <span className="btn btn-warning rounded-0  me-1 ">
                  <NavLink className="nav-link" smooth to="/client/work-orders-closed">
                    CLOSED
                  </NavLink>
                </span>

                <span className="btn btn-warning rounded-0  ">
                  <NavLink className="nav-link" smooth to="/client/work-orders-incomplete">
                    INCOMPLETE
                  </NavLink>
                </span>
              </div>
            </div>
          </div>


          <div className="row py-4 start-0  mx-auto ">

            <div className="col-md-6 col-sm-12  ">
              <h3 className="text-dark my-0">ACTIVE WORK ORDERS</h3>
            </div>

            <div className="col-md-6 col-sm-12 ps-3 text-end">

              <span className="btn btn-primary rounded-0 me-1">
                <NavLink className="nav-link" smooth to="/client/work-orders-new">
                  NEW
                </NavLink>
              </span>
              <span className="btn btn-danger rounded-0  me-1 ">
                <NavLink className="nav-link" smooth to="/client/work-orders-search">
                  SEARCH
                </NavLink>
              </span>

            </div>

          </div>



          <div className="card border-4 border-dark rounded-1 card-success mb-4" >

            <div className="card-body p-0" >

              <div className="row align-items-center p-3">

                  <div className="col-lg-7">
                    <div className="input-group">



                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search Patient, Facility, Client, Created By, Case #, Work Order ID..."
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                      />

                      <button className="btn btn-primary" type="button" onClick={handleSearch}>Search</button>

                      <button className="btn btn-secondary" type="button" onClick={handleReset}>Reset</button>

                      {appliedSearch && (
                        <span className="input-group-text">
                          Results: <strong className="ms-1">{filteredData.length}</strong>
                        </span>
                      )}

                    </div>
                  </div>

                  <div className="col-lg-5">
                    <div className="d-flex justify-content-md-end justify-content-start gap-2">

                      <span className="btn btn-outline-success btn-sm">
                        Total: <strong>{data.length}</strong>
                      </span>

                      
                    </div>
                  </div>

                </div>

              <CustomTable columns={columns} data={filteredData} />

            </div>
          </div>
        </>

      }
    </>
  );
};

export default ActiveWorkOrders;